import React from 'react';
import { connect } from 'react-redux';
import { KeyLicenseTypes } from '../common/keyLicenseTypes';
import { showModalMessage } from '../store/modalsSlice';
import * as objectHistory from '../store/objectHistorySlice';
import { objectHistoryNames, objectHistorySelectors } from '../store/objectHistorySlice';
import { offlineLicensesSelectors } from '../store/offlineLicensesSlice';
import OfflineLicenseHistoryTableHeader from '../components/offlineLicenseHistoryTableHeader';

import KeyLicenseHistoryDialog from '../components/keyLicenseHistoryDialog';

class OfflineLicenseHistoryDialog extends KeyLicenseHistoryDialog {
  get LicenseType() {
    return KeyLicenseTypes.Offline;
  }

  renderBeforeContent() {
    const objectData = this.props.selectedOfflineLicense(this.props.id);
    const editedFields = this.props.getEditedFields();
    return <OfflineLicenseHistoryTableHeader editedFields={editedFields} objectData={objectData}/>;
  }
}

const mapStateToProps = state => ({
  objectState: objectHistorySelectors.offlineLicenses(state),
  getEditedFields: () => objectHistorySelectors.offlineLicensesEditedFields(state),
  selectedOfflineLicense: (id) => offlineLicensesSelectors.selectById(state, id),
});

const actionCreators = {
  fetchHistory: id => objectHistory.fetchHistory(id, objectHistoryNames.offlineLicenses),
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(OfflineLicenseHistoryDialog);



// WEBPACK FOOTER //
// ./src/containers/offlineLicenseHistoryDialog.js